import { render, staticRenderFns } from "./EvaluationsGrid.vue?vue&type=template&id=77b454a3&scoped=true&"
import script from "./EvaluationsGrid.vue?vue&type=script&lang=js&"
export * from "./EvaluationsGrid.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationsGrid.vue?vue&type=style&index=0&id=77b454a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b454a3",
  null
  
)

export default component.exports